import React, { useEffect, useState } from "react";
import ServiceCard from "./ServiceCard";
import { Col } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import weatherImg from "../assets/images/weather.png";
import guideImg from "../assets/images/guide.png";
import customizationImg from "../assets/images/customization.png";

const servicesData = [
  {
    imgUrl: weatherImg,
    title: "Car Rental",
    desc: "Explore your destination with ease by renting a vehicle of your choice. Discover the freedom of the open road and travel at your own pace.",
  },
  {
    imgUrl: guideImg,
    title: "Best Tour Guide",
    desc: "Elevate your travel experience with a knowledgeable and passionate tour guide. Unlock the secrets of your destination through their expertise.",
  },
  {
    imgUrl: customizationImg,
    title: "Local Activities And Tours",
    desc: "Immerse yourself in the culture and beauty of your destination with a variety of handpicked local activities and tours. Visit and have splendid moment.",
  },
];

const ServiceList = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable automatic scrolling
    autoplaySpeed: 2000,
  };

  return (
    <>
      {isMobile ? (
        <Slider {...settings}>
          {servicesData.map((item, index) => (
            <div key={index} className="mb-4">
              <Col lg="3" md="6" sm="12">
                <ServiceCard item={item} />
              </Col>
            </div>
          ))}
        </Slider>
      ) : (
        <>
          {servicesData.map((item, index) => (
            <Col key={index} lg="3" md="6" sm="12" className="mb-4">
              <ServiceCard item={item} />
            </Col>
          ))}
        </>
      )}
    </>
  );
};

export default ServiceList;
